import React from 'react'
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { ColumnFixing, DataGrid, Editing, GroupItem, IDataGridOptions, Paging, Selection, Summary, TotalItem } from "devextreme-react/data-grid";
import { exportDataGrid as exportDataGridToXLS } from "devextreme/excel_exporter";
import { exportDataGrid as exportDataGridToPDF } from "devextreme/pdf_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import JsPdf from "jspdf";
import { Modal } from "react-bootstrap";
import useModel from "shared/hooks/useModel";
import { useForm } from "react-hook-form";
import { useLocalStorage } from "react-use";
import InputFields from "shared/component/inputFields";
import { DropDownButton } from "devextreme-react/drop-down-button";
import { Button } from "devextreme-react/button";
import { IPopupOptions } from "devextreme-react/popup";
import { useTranslation } from "react-i18next";
import { SelectBox } from "devextreme-react/select-box";
import Close from "shared/assets/images/svg/close_dialog.svg";
import RefreshIcon from 'shared/assets/images/svg/refresh_light.svg'
import PrintIcon from 'shared/assets/images/svg/printer_light.svg'
import Setting from 'shared/assets/images/svg/settings_light.svg'
import { usePaginate } from "shared/hooks/use-paginate";
import { Column, LoadPanel, IColumnProps, RemoteOperations } from "devextreme-react/data-grid";
import { useLocalize } from "shared/helpers/language";
import _ from "lodash";
import { Tab, Tabs } from "@mui/material";
import { atom, useRecoilState } from 'recoil';
import { useFormField } from 'shared/hooks/useFormField';
import { DxfCheckbox } from '../form-fields/dxf-checkbox';
import ExlIcon from 'shared/assets/images/svg/microsoft_excel.svg'
import { AmiriFont } from "./font";
const Input = InputFields 

export const DataTableAction = ({gridRef,dataSource,layoutKey,children}) => {
  const { t } = useTranslation();
  const [isUpdatingSetting, openSetting, closeSetting] = useModel();
  const [isSavingLayout, showSaveLayout, closeSaveLayout] = useModel(false);

  const [layouts, setLayouts] = useLocalStorage(layoutKey, undefined, {
    raw: false,
    serializer: (map) => JSON.stringify(Array.from(map.entries())),
    deserializer: (value) => new Map(JSON.parse(value)),
  });
  const layoutArray = Array.from(layouts?.keys() ?? []);

 // Selecting
 function selectAll() {
  gridRef.current?.instance.selectAll();
}
//const withFilterRow = _.isArray(props.dataSource) ? !!props.dataSource.length : !!props.dataSource;

function selectNone() {
  gridRef.current?.instance.deselectAll();
}

// Editing
function addRow() {
  gridRef.current?.instance?.addRow();
}

function deleteRow() {
  const selectRow = gridRef.current?.instance.getSelectedRowKeys();
  const selectRowIndex = gridRef.current?.instance.getRowIndexByKey(selectRow?.[0]);
  gridRef.current?.instance.deleteRow(selectRowIndex);
}

function editRow() {
  const selectRow = gridRef.current?.instance.getSelectedRowKeys();
  const selectRowIndex = gridRef.current?.instance.getRowIndexByKey(selectRow?.[0]);
  gridRef.current?.instance.editRow(selectRowIndex);
}
function saveLayout(data) {
  const map = layouts ?? new Map();
  const state = gridRef.current?.instance.state();
  //state.dxf = JSON.stringify(columns);
  map.set(data.name, state);
  setLayouts(map);
  closeSaveLayout();
}

function loadLayout(key) {
  if(key.id === "save-layout") return showSaveLayout();
  const state = layouts?.get(key);
  gridRef.current?.instance.state(state);
  //setColumns(JSON.parse(state.dxf));
}
// Exporting
function exportToXls(selectedRowsOnly = false) {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet("Main sheet");
  const isSelected = gridRef.current?.instance.getSelectedRowKeys().length > 0;
  exportDataGridToXLS({
    component: gridRef.current?.instance,
    worksheet,
    selectedRowsOnly:isSelected,
    topLeftCell: { row: 4, column: 1 },
  }).then((cellRange) => {
    // header
    const headerRow = worksheet.getRow(1);
    const headerRow2 = worksheet.getRow(2);
    const headerRow3 = worksheet.getRow(3);


    headerRow.height = 30;
    headerRow2.height = 30;
    headerRow3.height = 30;

    worksheet.mergeCells(2, 1, 2, 8);

    headerRow.getCell(1).value = 'PageName: my Booking';

   
    headerRow2.getCell(1).value = 'from:';
    headerRow3.getCell(1).value = 'to:';


  }).then(() => {
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer], { type: "application/octet-stream" }), "DataGrid.xlsx");
    });
  });
}

function exportToPdf() {
  const doc = new JsPdf();

  doc.addFileToVFS("Amir.ttf", AmiriFont);
  doc.addFont("Amir.ttf", "Amir", "normal");
  doc.setFont("Amir");

  exportDataGridToPDF({
    jsPDFDocument: doc,
    component: gridRef.current?.instance,
    indent: 5,
  })
  .then(() => {
    doc.autoPrint();
    doc.save()
  });
}
const [columns,setColumns] = useRecoilState(columnsState);

React.useEffect(() => {
  const gridColumns = React.Children.map(children, (child) => {
      if (React.isValidElement(child) && child.type === Column) {
        return { ...child.props };
      }
    } );
  setColumns(gridColumns ?? []);
},[])

  return (
    <>
     <div className=" dataTable-action">
    <div className="d-flex left-side">
    <SelectBox className="btn-select" placeholder={t('dxf-grid.select-view')} dataSource={layoutArray} onValueChange={loadLayout} stylingMode="outlined"  >
      
    </SelectBox> 
    </div>

    <div className="d-flex right-side">
    <button className="btn-refresh btn-single"  onClick={() => gridRef.current?.instance.refresh()}><img  src={RefreshIcon} alt="refresh"/></button>
    <button  className="btn-print  btn-single"  onClick={()=>exportToPdf()}> <img src={PrintIcon} alt="print"/>  </button>
    <div className="all-btn">
    <button   className="btn-single" onClick={()=>exportToXls()}><img src={ExlIcon} alt="svg" /></button>
    {/* <button className="btn-send btn-tbl">{t('dxf-grid.send')}</button>
    <button className="btn-select-all btn-tbl" onClick={()=>selectAll()}>{t('dxf-grid.select')}</button> */}
    {/* <button className="btn-views btn-tbl">{t('dxf-grid.view')}</button> */}
    </div>
      <button className="btn-single" onClick={()=> openSetting()}> <img src={Setting} alt="Setting" /> </button>
    </div>

    {/* <DropDownButton
      className="btn-select"
      splitButton
      text="export to xls"
      items={[{ id: 1, name: "EXPORT TO PDF" }]}
      displayExpr="name"
      onItemClick={exportToPdf}
      onButtonClick={() => exportToXls()}
    ></DropDownButton>
    <DropDownButton
      className="btn-select"
      splitButton
      text="select all"
      items={[{ id: 1, name: "SELECT NONE" }]}
      displayExpr="name"
      onButtonClick={selectAll}
      onItemClick={selectNone}
    ></DropDownButton>
    <DropDownButton
      className="btn-select"
      splitButton
      text="save layout"
      items={[{ id: 1, name: "DELETE LAYOUT" }]}
      displayExpr="name"
      onButtonClick={showSaveLayout}
    ></DropDownButton>

    <SelectBox className="btn-select" placeholder="SELECT LAYOUT" dataSource={layoutArray} onValueChange={loadLayout} /> */}
     {/* <DropDownButton
      className="btn-select"
      splitButton
      text="save layout"
      items={[{ id: 1, name: "DELETE LAYOUT" }]}
      displayExpr="name"
      onButtonClick={showSaveLayout}
    ></DropDownButton> */}
  </div>
      <SaveLayoutDialog show={isSavingLayout} onHide={closeSaveLayout}  saveLayout={saveLayout} />
      <SettingDialog show={isUpdatingSetting} onHide={closeSetting} />

    </>
   

  )
}

function SaveLayoutDialog({ show, onHide, saveLayout }) {
  const { t } = useTranslation();
  const saveLayoutForm = useForm();

  return (
    <Modal show={show} centered className="all-modal Admin-Modal save-layout">
      <Modal.Body>
        <div className="header">
          <div className="check-title">
            <h1>Settings</h1>
          </div>
          <img src={Close} alt="back" onClick={onHide} />
        </div>
        <form onSubmit={saveLayoutForm.handleSubmit(saveLayout)}>
          <Input
            label="layout name"
            type="text"
            {...saveLayoutForm.register("name", { required: t("errors.required") })}
          />
          <button className="btn-blue d-block w-100" type="submit">
            Save
          </button>
        </form>
      </Modal.Body>
    </Modal>
  );
}

function SettingDialog({ show, onHide }) {
  const [currentTab, setCurrentTab] = React.useState("appearance");
  return (
    <Modal show={show} centered className="all-modal Admin-Modal save-layout" size='lg'>
      <Modal.Body>
        <div className="header">
          <div className="check-title">
            <h1>Save Layout</h1>
          </div>
          <img src={Close} alt="back" onClick={onHide} />
        </div>
        <hr className='hr'/>
        <div className="content">
        <div className="row">
          <div className="col-xl-3 col-md-12 col-sm-12">
            <Tabs orientation="vertical" value={currentTab} onChange={(e, tab) => setCurrentTab(tab)}>
              <Tab label="appearance" value="appearance" />
              <Tab label="Grouping" value="grouping" />
              <Tab label="Paging" value="paging" />
              <Tab label="Column Settings" value="columnSettings" />
              <Tab label="Add Column" value="addColumn" />
            </Tabs>
          </div>
          <div className="col-xl-9 col-md-12 col-sm-12  all-content">
            {currentTab === "appearance" && <AppearanceSettings />}
            {currentTab === "grouping" && <GroupingSettings />}
            {currentTab === "paging" && <PagingSettings />}
            {currentTab === "columnSettings" && <ColumnSettings  />}
            {currentTab === "addColumn" && <AddColumn />}
          </div>
        </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export const groupPanelState = atom({
  key: "groupingSettingsState",
  default: {
    visible: true,
  },
});

function GroupingSettings() {
  const [groupPanel, setGroupPanel] = useRecoilState(groupPanelState);

  const groupForm = useForm({
    defaultValues: groupPanel,
  });

  return (
    <form onSubmit={groupForm.handleSubmit(setGroupPanel)}>
              <div className="content-info">
      <div className="row">
        <DxfCheckbox label="Show Group Panel" name="visible" control={groupForm.control} />
      </div>
      <div className="row">
        <DxfCheckbox label="Show Group Summery" name="visible" control={groupForm.control} />
      </div>
      </div>
      <div className='d-flex'>
      <button className="btn-blue d-block w-100" type="submit">
        Apply
      </button>
      <button className="btn-border-blue d-block w-100" type="submit">
        cancel
      </button>
      </div>

    </form>
  );
}

export const pagerSettingState = atom({
  key: "pagerSettingState",
  default: {
    visible: true,
    showPageSizeSelector: true,
    allowedPageSizes: [25, 50, 100, 'all'],
    showInfo: true,
    showNavigationButtons: true,
    showPageSizes: true,
  },
});

function PagingSettings() {
  const [pagerSettings, setPagerSettings] = useRecoilState(pagerSettingState);

  const pagerForm = useForm({
    defaultValues: pagerSettings,
  });

  return (
    <form onSubmit={pagerForm.handleSubmit((data) => setPagerSettings(data))}>
        <div className='content-info'>
      <div className="row">
        <DxfCheckbox label="Show Page Size Selector" name="showPageSizeSelector" control={pagerForm.control} />
        <DxfCheckbox label="Show Info" name="showInfo" control={pagerForm.control} />
        <DxfCheckbox label="Show Navigation Buttons" name="showNavigationButtons" control={pagerForm.control} />
        <DxfCheckbox label="Show Page Sizes" name="showPageSizes" control={pagerForm.control} />
      </div>
      </div>
      <div className='d-flex'>
      <button className="btn-blue d-block w-100" type="submit">
        Apply
      </button>
      <button className="btn-border-blue d-block w-100" type="submit">
        cancel
      </button>
      </div>

    </form>
  );
}

export const appearanceSettingsState = atom({
  key: "appearanceSettingsState",
  default: {
    showBorders: true,
    showRowLines: true,
    showColumnLines: true,
    allowColumnResizing: true,
  },
});

function AppearanceSettings() {
  const [appearanceSettings, setAppearanceSettings] = useRecoilState(appearanceSettingsState);
  const appearanceForm = useForm({
    defaultValues: appearanceSettings,
  });

  return (
    <form onSubmit={appearanceForm.handleSubmit(setAppearanceSettings)}>
                 <div className="content-info">
      <div className="row">
        <DxfCheckbox label="Show Column Lines" control={appearanceForm.control} name="showColumnLines" />
        <DxfCheckbox label="Show Row Lines" control={appearanceForm.control} name="showRowLines" />
        <DxfCheckbox label="Show Borders" control={appearanceForm.control} name="showBorders" />
        <DxfCheckbox label="Show Alternative Row" control={appearanceForm.control} name="rowAlternationEnabled" />
        <DxfCheckbox label="Allow Column Resizing" control={appearanceForm.control} name="allowColumnResizing" />
      </div>
      </div>
      <div className='d-flex'>
      <button className="btn-blue d-block w-100" type="submit">
        Apply
      </button>
      <button className="btn-border-blue d-block w-100" type="submit">
        Apply
      </button>

      </div>
    </form>
  );
}

export const columnsState = atom({
  key: "columnsState",
  default: [],
  dangerouslyAllowMutability: true,
});

function ColumnSettings() {
  const [columns, setColumns] = useRecoilState(columnsState);
  const [col, setCol] = React.useState(null);

  const columnForm = React.useMemo(() => {
    return columns.reduce((acc, col) => {
      acc[col.dataField] = col;
      return acc;
    }, {});
  }, [columns]);

  const form = useForm({
    defaultValues: columnForm,
  });

  React.useEffect(() => {
    form.reset({
      [col?.dataField]: col,
    });
  }, [col, form]);

  const { getFieldProps } = useFormField(form);

  const onSubmit = (data) => {
    const newColumns = columns.map((col) => {
      const newCol = data[col.dataField];
      return { ...col, ...newCol };
    });
    setColumns(newColumns);
  };

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className='content-info'>
      <div className="row">
        <div className="col-6">
          {columns.filter(c => !!c.caption).map((col) => (
            <div className="card p-1 mb-2" key={col.dataField} onClick={() => setCol(col)}>
              {col.caption}
            </div>
          ))}
        </div>
        {col && (
          <div className="col-6">
            <InputFields type="text" label="Column Name" {...getFieldProps(`${col.dataField}.caption`)} />
            <InputFields type="text" label="Field Type" {...getFieldProps(`${col.dataField}.dataType`)} />
          </div>
        )}
      </div>
      </div>
      <div className='d-flex'>
      <button className="btn-blue d-block w-100" type="submit">
        Apply
      </button>
      <button className="btn-border-blue d-block w-100" type="submit">
        cancel
      </button>

      </div>
    </form>
  );
}

function AddColumn() {
  const [columns, setColumns] = useRecoilState(columnsState);

  const columnSchema = React.useMemo(() => {
    return yup.object().shape({
      caption: yup.string().required(),
      dataField: yup.string().required(),
      dataType: yup.string().required(),
    });
  }, []);

  const form = useForm({
    defaultValues: {
      isNew: true,
      caption: "",
      dataField: "",
      dataType: "",
    },
    resolver: yupResolver(columnSchema),
  });

  const {getFieldProps} = useFormField(form);

  const onSubmit = (data) => {
   setColumns([...columns, data]);
  };

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className='content-info'>
      <div className="row">
          <InputFields type="text" label="Field Name" {...getFieldProps('dataField')} />
        <InputFields type="text" label="Field Type" {...getFieldProps('dataType')} />
        <InputFields type="text" label="Column Name" {...getFieldProps('caption')} />
      </div>
      </div>
      <div className='d-flex'>
      <button className="btn-blue d-block w-100" type="submit">
        Add
      </button>
      <button className="btn-border-blue d-block w-100" type="submit">
        cancel
      </button>
      </div>

    </form>
  );
}